import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Nav from './components/Nav';
import Hero from './components/Hero';
import Trust from './components/Trust';
import Services from './components/Services';
import ClientPartners from './components/ClientPartners';
import Footer from './components/Footer';
import Testimonials from './components/Testimonials';
import Recognition from './components/Recognition';

// Import page components (we'll create these)
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import ServicesPage from './pages/ServicesPage';
import Facts from './components/Facts';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <Router>
      <div className="App">
        <Nav />
        <main>
          <Routes>
            <Route path="/" element={
              <>
                <Hero />
                <Trust />
                <Services />
                <Facts />
                <ClientPartners />
                <Testimonials />
                <Recognition />
              </>
            } />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/services" element={<ServicesPage />} />
          </Routes>
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </Router>
  );
}

export default App;
